module.exports = __webpack_public_path__ + "7942bccbe6f775c88769deca528b85ab.svg";